import { render, staticRenderFns } from "./account-linking.vue?vue&type=template&id=a07c74a2&scoped=true"
import script from "./account-linking.vue?vue&type=script&lang=js"
export * from "./account-linking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07c74a2",
  null
  
)

export default component.exports